<ng-container [formGroup]="parent">
	<table mat-table class="list-container mb-3" [dataSource]="dataSource" matSort matSortActive="{{ sort.active }}"
		matSortDisableClear formArrayName="array" matSortDirection="{{ sort.direction }}">
		<ng-container matColumnDef="empty">
			<th mat-header-cell *matHeaderCellDef class="text-center">
				<em [class.warn-text]="showRequiredError">No addresses added yet</em>
			</th>
		</ng-container>

		<ng-container matColumnDef="address">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
			<td mat-cell *matCellDef="let companyAddress">
				{{ formatAddress(companyAddress.address) }}
			</td>
		</ng-container>

		<ng-container matColumnDef="isDefault">
			<th mat-header-cell *matHeaderCellDef>Default</th>
			<td mat-cell *matCellDef="let companyAddress">
				<mat-checkbox [checked]="companyAddress.isDefault"
					(change)="setAsDefault(companyAddress)"></mat-checkbox>
			</td>
		</ng-container>

		<ng-container matColumnDef="edit">
			<th mat-header-cell *matHeaderCellDef>Edit</th>
			<td mat-cell *matCellDef="let companyAddress">
				<button type="button" mat-icon-button (click)="editAddress(companyAddress)" color="primary">
					<mat-icon>edit</mat-icon>
				</button>
			</td>
		</ng-container>

		<ng-container matColumnDef="delete">
			<th mat-header-cell *matHeaderCellDef>Delete</th>
			<td mat-cell *matCellDef="let companyAddress">
				<button type="button" mat-icon-button color="warn" rpsharedConfirm="Delete address?"
					(onConfirmed)="array.removeAt(findAddressIndex(companyAddress))">
					<mat-icon>delete</mat-icon>
				</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="resultColumns" [class.hidden]="dataSource.data?.length < 1"></tr>
		<tr mat-header-row *matHeaderRowDef="emptyColumns" [class.hidden]="dataSource.data?.length > 0"></tr>
		<tr mat-row *matRowDef="let companyAddress; columns: resultColumns" [@animateList]></tr>
	</table>

	<div fxLayout fxLayoutAlign="space-between center">
		<mat-paginator class.hidden="true" pageSize="5" [pageSizeOptions]="[5, 10]"></mat-paginator>
		<button type="button" class="mr-4" (click)="addAddress()" mat-mini-fab color="primary" matTooltip="Add Address">
			<mat-icon>add</mat-icon>
		</button>
	</div>
</ng-container>